import colors from '../theme/colors';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import Logo from './Logo';
import styles from './muiStyles';

const AppHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        ...styles.appBar,
        backgroundColor: colors.grey.t700,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          aria-label="toolbar"
          sx={{
            ...styles.toolbar,
            flexDirection: isMobile ? 'column' : 'row',
            paddingTop: isMobile ? 2 : 0,
            paddingBottom: isMobile ? 2 : 0,
          }}
        >
          <Logo />
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              marginTop: isMobile ? 2 : 0,
              position: isMobile ? 'relative' : 'absolute',
              right: isMobile ? 'auto' : 0,
            }}
          >
            <Button
              variant="contained"
              sx={{
                ...styles.button.login,
                ...styles.button.topLogin,
              }}
              component={Link}
              to="/sign-in"
            >
              Login
            </Button>
            <Button
              variant="contained"
              sx={{
                ...styles.button.signup,
                ...styles.button.topSignup,
              }}
              component={Link}
              to="/sign-up"
            >
              Sign up
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default AppHeader;
